<script setup>
import { useLayout } from 'src/composables/useLayout'
import { ref, watch } from 'vue'
import CombinedFullProduct from 'pages/CombinedFullProduct'
import { server } from 'boot/meteor'

const props = defineProps(['url'])
const { locale } = useLayout()
const product = ref(null)
const loadProduct = async () => {
  product.value = await server.call('loadProduct', { url: props.url, iso: locale.value })
}
watch(props, async () => {
  await loadProduct()
})
await loadProduct()
</script>

<template lang="pug">
.full-width(style="min-height: 1000px")
  combined-full-product(
    v-if="product"
    :product-name="product.product_name"
    :product-img="product.img"
    type="PRODUCT"
    :products="[product]"
  )
</template>
